import React from 'react';

import VaultIconSvg from 'components/vaults/images/VaultIconSvg';
import { useOwnVaultQuery } from 'components/vaults/shared/utils';
import { useSelector } from 'reduxState/store';

import { MenuItemType } from '../headerTypes';
import MenuItemRenderer from '../MenuItemRenderer';

/** Vault owner Link (Optional) */
function VaultOwnerItem() {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const ownVault = useOwnVaultQuery();

  if (!ownVault || !walletAddress) {
    return null;
  }

  return (
    <MenuItemRenderer
      menuItem={{
        type: 'DropdownMenuLink' as const,
        label: ownVault.name || 'My Vault',
        to: `/vaults/${walletAddress}`,
        icon: <VaultIconSvg color="currentColor" size={17} />,
      }}
    />
  );
}

const vaultOwnerItem: MenuItemType = {
  type: 'MenuBox',
  Component: VaultOwnerItem,
};

export default vaultOwnerItem;
